var getUserType = require('../utils/get-user-type')
var reactDirtyRoute = require('../mixins/react-dirty-route')
var billsView = require('../mixins/bills-view')
var contactsView = require('../mixins/contacts-view')
var transactionsView = require('../mixins/transactions-view')
var productShineCallback = require('../mixins/product-shine-callback')
var openBankingCallback = require('../mixins/open-banking-callback')

module.exports = Em.ObjectController.extend(reactDirtyRoute, billsView, contactsView, transactionsView, productShineCallback, openBankingCallback, {
    needs: ['application', 'user', 'organization'],

    activeUmbrella: Em.computed.alias('sideMenu.activeUmbrella'),

    activeMembership: Em.computed.oneWay('userOrganizations.activeMembership'),

    activeOrganization: Em.computed.alias('controllers.user.activeOrganization'),

    organization: Em.computed.alias('controllers.organization.model'),

    userType: function() {
        return getUserType(this.get('activeMembership'))
    }.property('activeMembership'),

    customActions: function() {
        return _.merge(this.get('_customActions'), this.get('_customActionsBills'), this.get('_customActionsContacts'), this.get('_customActionsTransactions'), {})
    }.property('_customActions', '_customActionsBills', '_customActionsTransactions')
})
